import {DND_HANDLE_COLUMN_WIDTH, ADD_COLUMN_WIDTH} from "./columns";

// const debug = "WidthCalculatorColumns"
const debug = false

export default class WidthCalculatorFixed {

    private columnsManager  : any

    constructor(columnsManager:any) {
        debug && console.log(debug, "constructor()", columnsManager)

        this.columnsManager     = columnsManager
    }

    calculateTotalWidth():number {
        let totalWidth = 0

        _.map(this.columnsManager._columns, (column)=>{
            if (column.isHidden) return // skip hidden columns
            totalWidth += column.width
        })

        // patches
        totalWidth += this.columnsManager.module.skin.paddingLeft + this.columnsManager.module.skin.paddingRight
        if (this.columnsManager.module.canDndItems)    totalWidth += DND_HANDLE_COLUMN_WIDTH
        if (this.columnsManager.module.canAddColumns)  totalWidth += ADD_COLUMN_WIDTH

        return totalWidth

    }



}